/**
 * Thrown when the gasless relayer configuration is invalid.
 *
 * A relayer recovers the order signer against ONE deployment. Pointing a build
 * at another chain's relayer makes it reject a perfectly valid signature, so a
 * misconfiguration is never silently repaired — it fails at boot.
 */
export class RelayerConfigError extends Error {
  constructor(message: string) {
    super(`[Relayer] ${message}`);
    this.name = "RelayerConfigError";
    // Required for `instanceof` to work when targeting ES5 (tsconfig target).
    Object.setPrototypeOf(this, RelayerConfigError.prototype);
  }
}
